;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.FavouritePlayer = Backbone.Model.extend({
		url: 'favourite_player/show_my'
	});

}(window, APP, Backbone, Marionette, $, _));
